import { createListenerMiddleware, isAnyOf } from '@reduxjs/toolkit';
import { setPlanoAtual } from '../sharedActions';

export const persistUserMiddleware = createListenerMiddleware();

let lastSnapshot = null;

persistUserMiddleware.startListening({
  predicate: (action, currentState, previousState) => {
    const cur = currentState.user || {};
    const prev = previousState.user || {};
    return (
      cur.isLogged !== prev.isLogged ||
      cur.data?.matricula !== prev.data?.matricula ||
      cur.data?.token !== prev.data?.token ||
      cur.data?.plano !== prev.data?.plano
    );
  },
  effect: (_action, listenerApi) => {
    const { isLogged, data } = listenerApi.getState().user || {};

    const snapshot = {
      isLogged,
      matricula: data?.matricula,
      token: data?.token,
      plano: data?.plano,
    };

    if (JSON.stringify(snapshot) === JSON.stringify(lastSnapshot)) return;
    lastSnapshot = snapshot;

    if (isLogged && data?.matricula && data?.token) {
      localStorage.setItem('Id', data.matricula);
      localStorage.setItem('Matricula', data.matricula);
      localStorage.setItem('Token', data.token);

      if (data.plano) {
        localStorage.setItem('Plano', data.plano);
      }
    }
  },
});

persistUserMiddleware.startListening({
  matcher: isAnyOf(setPlanoAtual),
  effect: (action, listenerApi) => {
    const { data } = listenerApi.getState().user || {};
    if (data?.plano) {
      localStorage.setItem('Plano', data.plano);
    }
  },
});
